import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CONFIG from "./utils/config";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/font.css?v=1";
import "./assets/css/slick-slider-custom.css?v=1";
import "./assets/fonts/font.css";
import "./assets/css/font-awesome.css";
import "./assets/css/style.css?v=1";
// import "./assets/css/style-b2c.css?v=1";
import "./App.scss";
import "./assets/css/page.css?v=1";
// import "./assets/css/custom.css?v=1";
import "./assets/css/learning-path.css?v=1";
import "./assets/css/introduction.css?v=1";
import "./assets/css/media.css?v=1";
import "./assets/css/custom-brokarage-theme.css?v=1";

import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



import ResetPass from "./pages/ResetPassword/ResetPass";

import ProductPage from "./pages/ProductPage";
import NewsnArticles from "./pages/NewsArticles/NewsnArticles";
import MasterCodeOfEthicsPage from "./pages/courses/MasterCodeOfEthicsPage";
import NoteList from "./components/notes/NoteList";
import Favorites from "./pages/menuPages/Favorites";
import SetupPasswordPage from "./pages/SetupPasswordPage";
import ActivationLinkExpiryPage from "./pages/ActivationLinkPage";
import LearningPathsPage from "./pages/learningPaths/LearningPathsPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import CertifyPage from "./pages/certify/CertifyPage";
import MembershipPage from "./pages/Membership/MembershipPage";
import CartPage from "./pages/Cart/CartPage";
import OrderHistoryPage from "./pages/Orders/OrderHistoryPage";
import PaymentPage from "./pages/Orders/PaymentPage";
import ShoppingPage from "./pages/Cart/ShoppingPage";
import CourseMobileDetail from "./pages/courses/CourseMobileDetail";
import CourseLaunchPage from "./pages/courses/CourseLaunchPage";
import CourseLaunchMobilePage from "./pages/courses/CourseLaunchMobilePage";
import NewsnArticlesNoHeader from "./pages/NewsArticles/NewsArticlesNoHeader";
import CreditPoints from "./components/Cart/CreditPoints";
import CreditPointsHistoryPage from "./pages/courses/CreditPointsHistoryPage";
import LearningPoints from "./components/LearningPaths/LearningPoints";
import CalendarEvents from "././pages/Calender Events/CalenderEvents";
import MyEventsPage from "./pages/Events/MyEventsPage";
import PaymentMobilePage from "./pages/Orders/PaymentMobilePage";
import EventDetailMobilePage from "./pages/Events/EventDetailMobilePage";
import MyCoursesPage from "./pages/menuPages/MyCoursesPage";
import MyCertification from "./pages/menuPages/MyCertification";
import LoginHostInstPage from "./pages/LoginHostInstPage";
import CalendarHostEvents from "./pages/Calender Events/CalendarHostEvents";
import CalenderInstructorEvents from "./pages/Calender Events/CalenderInstructorEvents";
import MyWishList from "./pages/menuPages/MyWishList";
import MyOnboarding from "./pages/menuPages/MyOnboarding";
import AcceptRole from "./pages/menuPages/AcceptRole";
import MyLearningCenter from "./pages/menuPages/MyLearningCenter";
import ReportDashboard from "./pages/Reports/ReportDashboard";
import RolePlay from "./pages/RolePlay/RolePlay";
import ReviewRolePlay from "./pages/RolePlay/ReviewRolePlay";
import ReviewsRolePlays from "./pages/RolePlay/ReviewsRolePlays";
import ToReview from "./pages/RolePlay/ToReview";
import RolePlayMobile from "./pages/RolePlay/RolePlayMobile";
import ReviewRolePlayMobile from "./pages/RolePlay/ReviewRolePlayMobile";
import MyRolePlayMobile from "./pages/RolePlay/MyRolePlayMobile";
import OnboardReportPage from "./pages/Reports/OnboardReportPage";
import ProfileCompletionReportPage from "./pages/Reports/ProfileCompletionReportPage";
import LearningPathProgressReportPage from "./pages/Reports/LearningPathProgressReportPage";
import CourseProgressReportPage from "./pages/Reports/CourseProgressReportPage";
import CodeOfEthicsReportPage from "./pages/Reports/CodeOfEthicsReportPage";
import EventReportPage from "./pages/Reports/EventReportPage";
import PlanUpgradeReport from "./pages/Reports/PlanUpgradeReport";
import PurchaseReport from "./pages/Reports/PurchaseReport";
import PrivacyandTerms from "./pages/Privacy/PrivacyandTerms";
import MyWallPage from "./pages/myNetwork/MyWallPage";
import VideoPlayerPage from "./pages/videoCourses/VideoPlayerPage";
import Pdftron from "./components/Course/Pdftron";
// import Test from './components/Course/Test'
import ProgressReportPage from "./pages/Reports/progressReportPage";
import Test from "./components/Course/Test";
import ComplianceReportPage from "./pages/Reports/ComplianceReportPage";
import NotFoundPage from "./pages/NotFoundPage";
import LevelDetailPage from "./pages/learningPaths/LevelDetailPage";
import VideoPlayerBroadcastPage from "./pages/videoCourses/VideoPlayerBroadcastPage";
import CookiePolicy from "./pages/FooterSectionComp/CookiePolicy";
import PrivacyPolicy from "./pages/FooterSectionComp/PrivacyPolicy";
import TermsOfUse from "./pages/FooterSectionComp/TermsOfUse";
import MyVideosPage from "./pages/menuPages/MyVideosPage"
import ReportDashboardMobile from "./pages/Reports/ReportDashboardMobile";
import OnboardReportPageMobile from "./pages/Reports/OnboardReportPageMobile";
import LearningPathProgressReportPageMobile from "./pages/Reports/LearningPathProgressReportPageMobile";
import ComplianceReportPageMobile from "./pages/Reports/ComplianceReportPageMobile";
import CodeOfEthicsReportPageMobile from "./pages/Reports/CodeOfEthicsReportPageMobile";
import ProgressReportPageMobile from "./pages/Reports/progressReportPageMobile";
import AssignCourseModal from "./components/modal/AssignCourseModal";
import AssignContentPage from "./pages/mobilePages/AssignContentPage";
import CertificateAndBadgeMobile from "./pages/mobilePages/CertificateAndBadgeMobile";
import CalendarEventsMobilePage from "./pages/Calender Events/CalendarEventsMobilePage";
import ActivationFailureResetPage from "./pages/ActivationFailureResetPage";
// import Pdftron from './components/Course/Pdftron'
// import Test from './components/Course/Test'

import CourseListingPage from "./pages/courses/CourseListingPage";
import HomePage from "./pages/HomePage";
import ModuleDetail from "./pages/modulePages/moduleDetail";
import VideoCoursesListingPage from "./pages/videoCourses/VideoCoursesListingPage";
import EditProfilePage from "./pages/menuPages/EditProfilePage";
import MyToolBox from "./pages/Toolbox/MyToolBox";
import AllEventsPage from "./pages/Events/AllEventsPage";
// import EventDetailPage from "./pages/Events/EventDetailPage";
import MyRolePlays from "./pages/RolePlay/MyRolePlays";
import SearchPage from "./pages/SearchPage";
import VideoViewPage from "./pages/videoCourses/VideoViewPage";
import CertifiedDetailPage from "./pages/certify/CertifyDetailPage";


import ServerErrorPage from "./pages/ServerErrorPage";
import PrivacyandTermsMobile from "./pages/Privacy/PrivacyandTermsMobile";
import VideoViewPageMobile from "./pages/videoCourses/VideoViewPageMobile";
import DocumentView from "./components/ToolBox/DocumentView";
import VideoPlayerPageMobile from "./pages/videoCourses/VideoPlayerPageMobile";
import NotFoundPageWithouHeader from "./pages/NotFoundPage/NotFoundPageWithouHeader";
import LoginPage from "./pages/LoginPage";
import ChangePasswordPage from "./pages/ResetPassword/ChangePasswordPage";
import CourseCategories from "./pages/courses/CourseCategories";
import VideoCategoriesPage from "./pages/courses/VideoCategoriesPage";
import AgentProgressReportPage from "./pages/Reports/AgentReportPage";



import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import AssignedUserList from "./pages/courses/AssignedUserList";

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import ComplianceReportDetailPage from "./pages/Reports/ComplianceReportDetailPage";
import ComplianceReportDetailPageMobile from "./pages/Reports/ComplianceReportDetailPageMobile";
import ComplianceReportAgentDetailPage from "./pages/Reports/ComplianceReportAgentDetailPage";
import ComplianceReportAgentDetailPageMobile from "./pages/Reports/ComplianceReportAgentDetailPageMobile";
import LearningPathOfficeDetailPage from "./components/Reports/learningPathProgress/LearningPathOfficeDetailPage";
import LearningPathReaDetailPage from "./components/Reports/learningPathProgress/LearningPathReaDetailPage";
import LearningPathOfficeDetailMobilePage from "./components/Reports/learningPathProgress/LearningPathOfficeDetailMobilePage";
import LearningPathReaDetailMobilePage from "./components/Reports/learningPathProgress/LearningPathReaDetailMobilePage";
import SocialLoginActivation from "./pages/SocialLoginActivation";
import { AuthProvider } from "./utils/auth";
import { RequireAuth } from "./utils/RequireAuth";
import AccessCodePage from "./pages/AccessCodePage";
import FolderCreateFileUploadCompMobile from "./pages/Toolbox/FolderCreateFileUploadCompMobile";
import VideoPlayerBroadcastMobilePage from "./pages/videoCourses/VideoPlayerBroadcastMobilePage";
import FromSSOPage from "./pages/FromSSOPage";
import ProviderPage from "./pages/Provider/Provider";
import OurPartners from "./pages/Provider/OurPartners";
import Coaching from "./pages/Provider/Coaching";
import Description from "./pages/Provider/Description";
// import Courses from "./pages/Provider/Courses";
// import Videos from "./pages/Provider/Videos";
import ProviderDetailPage from "./pages/Provider/ProviderDetailPage";
import OtherServices from "./pages/Provider/OtherServices";
// import ProviderCourseCategory from "./pages/Provider/ProviderCourseCategory";
// import ProviderVideoCategory from "./pages/Provider/ProviderVideoCategory";
import ProviderCourseListingPage from "./pages/Provider/ProviderCourseListingPage";
import ProviderCourseCategories from "./pages/Provider/ProviderCourseCategories";
import ProviderVideoCategories from "./pages/Provider/ProviderVideoCategories";
import ProviderCertifiedDetailPage from "./pages/Provider/ProviderCertifyDetailPage";
import ProviderEventsPage from "./pages/Provider/ProviderEventsPage";
import MySubscriptionPage from "./pages/Orders/MySubscriptionPage";
import SystemUsageReports from "./pages/Reports/SystemUsageReports";
import SystemUsageReportsMobile from "./pages/Reports/SystemUsageReportsMobile";
import EventsCalendarPage from "./pages/Calender Events/EventsCalendarPage";
import HomePageB2C from "./pages/B2C-Pages/HomePageB2C";
import ProductCardPages from "./pages/TestPages/ProductCardPages";
import CertificationDetailsPage from "./pages/certifications/CertificationDetailsPage";
import LearnParentPage from "./pages/B2C-Pages/LearnParentPage";
import EventDetailPage from "./pages/B2C-Pages/EventPages/EventDetailPage"
import PartnerDetailPage from "./pages/B2C-Pages/partnerPage/PartnerDetailPage";
import CartPageB2c from "./pages/Cart/CartPageB2c";
import PaymentB2CPage from "./pages/Orders/PaymentB2CPage";
import RolePlayDetailComponent from "./components/NewDesign/RolePlay/RolePlayDetailComponent";
import RolePlayDetailPage from "./pages/B2C-Pages/RolePlayDetailPage";
import SubscriptionB2C from "./pages/B2C-Pages/SubscriptionPages/SubscriptionB2CPage";
import SignUpPage from "./pages/SignUpPage";
import PaymentB2CDetails from "./components/NewDesign/Payment/PaymentB2CDetails";
import PaymentStatusB2CPage from "./pages/Orders/PaymentStatusB2CPage";
import PaymentSummaryB2CPage from "./pages/Orders/PaymentSummaryB2CPage";
import PaymentMethodAddPage from "./pages/Orders/PaymentMethodAddPage";
import { routeList } from "./utils/routeList";
import ViewSubscriptionReceiptPage from "./pages/Orders/ViewSubscriptionReceiptPage";
import LiveEvents from "./components/NewDesign/Event/LiveEvents";
import LPDetailPage from "./pages/learningPaths/LPDetailPage";
import CoachingDetailPage from "./components/NewDesign/Coaching/CoachingDetailPage";
import EventsRegistrationPage from "./components/Calendar/EventsRegistrationPage";
import DetailLearnDiscussMobilePage from "./components/NewDesign/DetailPage/DetailLearnDiscuss/DetailLearnDiscussMobilePage";
import PaymentMethodAddMobilePage from "./pages/Orders/PaymentMethodAddMobilePage";
import PaymentB2CPageMobile from "./pages/Orders/PaymentB2CPageMobile";
import CoachingDetailPageMobile from "./components/NewDesign/Coaching/CoachingDetailPageMobile";
import PodcastAndFBFeedMobile from "./components/PodcastAndFBFeedMobile";
import BundleDetailPage from "./pages/learningPaths/BundleDetailPage";
import LPDetailPageMobile from "./pages/learningPaths/LPDetailPageMobile";
import TourDetailPage from "./pages/B2C-Pages/tour/TourDetailPage";
import OrderHistoryPageCopy from "./pages/Orders/OrderHistoryPageCopy";
import BundleDetailPageMobile from "./pages/learningPaths/BundleDetailPageMobile";
import { WebhookProvider } from "./utils/webhook";
import AssignedUserListMobile from "./pages/courses/AssignedUserListMobile";
import RolePlayReviewDetailPage from "./pages/B2C-Pages/RolePlayReviewDetailPage";
import ConditionalRenderingForSubscription from "./pages/B2C-Pages/SubscriptionPages/ConditionalRenderingForSubscription";
import RolePlayListingMainComponent from "./components/NewDesign/ListingContent/RolePlayListingContent/RolePlayListingMainComponent";
import MyTeamListPage from "./pages/myNetwork/MyTeamListPage";
import LeaderBoardPage from "./pages/LeaderBoard/LeaderBoardPage";
import BadgesMobile from "./pages/mobilePages/BadgesMobile";
import PartnerListPage from "./components/NewDesign/Partner/PartnerListPage";
import LiveEventsMarketingCalendar from "./components/NewDesign/Event/LiveEventsMarketingCalendar";
import LoginSSO from "./pages/LoginSSO";
import MarketingCalendar from "./components/Calendar/MarketingCalendar";
import EventsCalendarMobilePage from "./pages/Calender Events/EventsCalendarMobilePage";
import GoogleAuthCallback from "./pages/GoogleAuthCallback";
import GoogleAuthCall from "./pages/GoogleAuthCall";
import SubLoginPage from "./pages/SubLoginPage";
import SubscriptionPriceSectionUpdatedComp from "./components/NewDesign/SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionUpdatedComp";
import FlashTermAndCondPage from "./components/FooterSectComponents/FlashTermAndCondPage";
import FormBuilderSection from "./components/Survey/FormBuilderSection";
import FormGeneratorSection from "./components/Survey/FormGeneratorSection";
import FormGeneratorMobileSection from "./components/Survey/FormGeneratorMobileSection";
import FormBuilderPage from "./pages/FormBuilder/FormBuilderPage";
import FormBuilderMobilePage from "./pages/FormBuilder/FormBuilderMobilePage";
import FormGeneratorPage from "./pages/FormBuilder/FormGeneratorPage";
import LearningPathSurveyReport from "./pages/Reports/LearningPathSurveyReport";
import LearningPathSurveyReportMobile from "./pages/Reports/LearningPathSurveyReportMobile";
import FormGeneratorPageMobile from "./pages/FormBuilder/FormGeneratorPageMobile";
import SubscriptionPaymentsPage from "./pages/B2C-Pages/SubscriptionPages/SubscriptionPaymentsPage";

function App() {
    global.Buffer = global.Buffer || require("buffer").Buffer;
    return (
        <BrowserRouter>
            <AuthProvider>
                <WebhookProvider>
                    <Routes>
                        {/* <Route path="/" element={<LoginPage />} exact /> */}
                        <Route path="/login" element={<LoginPage />} exact />
                        <Route path="/home" element={
                            <RequireAuth>
                                <HomePage />
                            </RequireAuth>
                        } exact />
                        <Route path="/verify-user" element={<SubLoginPage />} exact />
                        {/* <Route path="/:company/login" element={<LoginPage isCompany="true" />} exact /> */}
                        <Route path="/resetPass" element={<ResetPass />} exact />
                        <Route path="/signup-by-access-code" element={<AccessCodePage />} exact />
                        <Route path="/setup-password" element={<SetupPasswordPage />} exact />

                        {/* <Route path="/provider-courses-page" element={<Courses />}/>
                    <Route path="/provider-videos-page" element={<Videos />}/> */}

                        <Route path="/provider-page" element={<ProviderPage />} />
                        {/* <Route path="/our-partners" element={<OurPartners />}/> */}
                        <Route path="/coaching" element={<Coaching />} />
                        <Route path="/description" element={<Description />} />
                        <Route path="/provider-details-page" element={<ProviderDetailPage />} />
                        <Route path="/other-services" element={<OtherServices />} />
                        <Route path="/provider-course-categories" element={<ProviderCourseCategories />} />
                        <Route path="/provider-video-categories" element={<ProviderVideoCategories />} />
                        <Route path="/provider-certify-detail" element={<ProviderCertifiedDetailPage />} />
                        <Route path="/provider-events" element={<ProviderEventsPage />} />


                        {/* <Route path="/provider-course-categories" element={
                        <RequireAuth>
                            <CourseCategories />
                        </RequireAuth>
                    } /> */}
                        <Route path="/provider-course-listing-page" element={<ProviderCourseListingPage />} />


                        <Route
                            path="/activation-expiry"
                            element={<ActivationLinkExpiryPage />}
                            exact
                        />
                        <Route
                            path="/activation-reset-expiry"
                            element={<ActivationFailureResetPage />}
                            exact
                        />
                        <Route path="/verify-email" element={<VerifyEmailPage />} exact />
                        {/* <Suspense fallback=''>
                    </Suspense> */}



                        {/* Profile Route */}
                        <Route path="/profile/edit" element={
                            <RequireAuth>
                                <EditProfilePage />
                            </RequireAuth>
                        } exact />

                        {/* Event Page */}
                        <Route path="/events" element={
                            <RequireAuth>
                                <AllEventsPage />
                            </RequireAuth>
                        } exact />
                        {/* <Route path="/event-detail" element={
                        <RequireAuth>
                            <EventDetailPage />
                        </RequireAuth>
                    } exact /> */}
                        <Route
                            path="/event-detail-mobile"
                            element={<EventDetailMobilePage />}
                            exact
                        />

                        {/* More Section Pages */}
                        <Route path="/my-courses" element={
                            <RequireAuth>
                                <MyCoursesPage />
                            </RequireAuth>
                        } exact />

                        <Route path="/notes" element={<NoteList />} exact />
                        <Route path="/favorites" element={<Favorites />} exact />

                        {/* Courses */}
                        <Route
                            path="/courseDetail/:courseCode"
                            element={<CourseLaunchPage />}
                            exact
                        />
                        <Route
                            path="/course/module/launch/:courseCode"
                            element={<CourseLaunchMobilePage />}
                            exact
                        />{" "}
                        {/* for mobile */}
                        <Route path="/courseListing" element={
                            <RequireAuth>
                                <CourseListingPage />
                            </RequireAuth>
                        } exact />
                        {/* <Suspense fallback=''>
                    </Suspense> */}
                        <Route path="/codeOfEthics" element={
                            <RequireAuth>
                                <MasterCodeOfEthicsPage />
                            </RequireAuth>
                        } exact />
                        {/* Learning Paths */}
                        <Route path="/learning-paths" element={
                            <RequireAuth>
                                <LearningPathsPage />
                            </RequireAuth>
                        } exact />
                        {/* Learning Points */}
                        <Route path="/learning-points" element={
                            <RequireAuth>
                                <LearningPoints />
                            </RequireAuth>
                        } exact />
                        {/* Modules */}
                        <Route path="/moduleDetail/:courseId" element={
                            // <RequireAuth>
                            // </RequireAuth>
                            // <RequireAuth>
                            <ModuleDetail />
                            // </RequireAuth>
                        } exact />
                        {/* <Suspense fallback=''>
                    </Suspense> */}
                        <Route
                            path="/courseModuleListing/:courseId"
                            element={<CourseMobileDetail />}
                            exact
                        />{" "}
                        {/* for mobile */}
                        {/* Video */}
                        <Route
                            path="/video-listing"
                            element={
                                <RequireAuth>
                                    <VideoCoursesListingPage />
                                </RequireAuth>
                            }
                            exact
                        />
                        {/* <Suspense fallback=''>
                    </Suspense> */}
                        {/* Cart */}
                        <Route path="/cart" element={
                            <CartPageB2c />
                            // <RequireAuth>
                            // </RequireAuth>
                        } exact />
                        <Route path={routeList.CART_PAGE} element={
                            <CartPageB2c />
                            // <RequireAuth>
                            // </RequireAuth>
                        } exact />
                        {/* Shopping */}
                        <Route path="/shopping/:courseId" element={
                            <RequireAuth>
                                <ShoppingPage />
                            </RequireAuth>} exact />
                        {/* Orders */}
                        <Route path="/orders" element={
                            <RequireAuth>
                                <OrderHistoryPageCopy />
                            </RequireAuth>
                        } exact />
                        <Route path="/payment" element={
                            // <RequireAuth>
                            <PaymentPage />
                            // </RequireAuth>
                        }
                            exact />
                        <Route path="/payment/mobile" element={<PaymentMobilePage />} exact />
                        {/* Credit points */}
                        <Route path="/credit-points" element={
                            <RequireAuth>
                                <CreditPoints />
                            </RequireAuth>
                        } exact />
                        <Route
                            path="/credit-points-history"
                            element={
                                <RequireAuth>
                                    <CreditPointsHistoryPage />
                                </RequireAuth>
                            }
                            exact
                        />
                        {/* Products */}
                        <Route path="/product/:slug" element={
                            <RequireAuth>
                                <ProductPage />
                            </RequireAuth>
                        } exact />
                        <Route path="/product" element={
                            <RequireAuth>
                                <ProductPage />
                            </RequireAuth>
                        } exact />
                        {/* Resources */}
                        <Route path="/news-articles" element={<NewsnArticles />} exact />
                        <Route
                            path="/device/news-articles"
                            element={<NewsnArticlesNoHeader />}
                            exact
                        />{" "}
                        {/* for mobile */}
                        {/* Search Result */}
                        <Route path="/search" element={
                            // <RequireAuth>
                            <SearchPage />
                            // </RequireAuth>
                        } exact />
                        {/* Certify */}
                        <Route path="/certify" element={
                            <RequireAuth>
                                <CertifyPage />
                            </RequireAuth>
                        } exact />
                        {/* Membership */}
                        <Route path="/membership" element={
                            <RequireAuth>
                                <MembershipPage />
                            </RequireAuth>
                        } exact />

                        {/* Calender Events/Sessions */}
                        <Route path="/calendar-events" element={
                            // <RequireAuth>
                            <CalendarEvents />
                            // </RequireAuth>
                        } exact />
                        <Route path="/events-calendar" element={
                            // <RequireAuth>
                            <EventsCalendarPage />
                            // </RequireAuth>
                        } exact />
                        <Route path="/events-calendar/iframe" element={
                            <RequireAuth>
                                <EventsCalendarMobilePage />
                            </RequireAuth>
                        } exact />
                        <Route path="/calendar-events/iframe" element={<CalendarEventsMobilePage />} exact />
                        <Route path="/calendar/host" element={
                            <RequireAuth>
                                <CalendarHostEvents />
                            </RequireAuth>
                        } exact />
                        <Route
                            path="/calendar/instructor"
                            element={
                                <RequireAuth>
                                    <CalenderInstructorEvents />
                                </RequireAuth>
                            }
                            exact
                        />


                        <Route path="/my-events" element={
                            <RequireAuth>
                                <MyEventsPage />
                            </RequireAuth>
                        } exact />
                        <Route path="/session/watch" element={
                            <RequireAuth>
                                <VideoPlayerPage />
                            </RequireAuth>
                        } exact />
                        <Route path="/session/watch-mobile" element={<VideoPlayerPageMobile />} exact />
                        <Route path="/session/broadcast/watch" element={
                            <RequireAuth>
                                <VideoPlayerBroadcastPage />
                            </RequireAuth>
                        } exact />
                        <Route path="/session/broadcast/mobile/watch" element={
                            <VideoPlayerBroadcastMobilePage />
                        } exact />
                        {/* Certified */}
                        {/* <Route path="/certify-detail" element={
                        <RequireAuth>
                            <CertifiedDetailPage />
                        </RequireAuth>
                    } exact /> */}
                        {/* Certificate */}
                        <Route path="/my-certificates" element={
                            <RequireAuth>
                                <MyCertification />
                            </RequireAuth>
                        } />
                        {/* Host Instructor Login */}
                        <Route path="/host-inst/login" element={<LoginHostInstPage />} />
                        <Route path="/wishlist" element={
                            // <RequireAuth>
                            <MyWishList />
                            // </RequireAuth>
                        } />
                        <Route path="/my-onboarding" element={
                            <RequireAuth>
                                <MyOnboarding />
                            </RequireAuth>
                        } exact />
                        <Route path="/accept-role" element={
                            <RequireAuth>
                                <AcceptRole />
                            </RequireAuth>} exact
                        />
                        <Route path="/learning_center" element={
                            <RequireAuth>
                                <MyLearningCenter />
                            </RequireAuth>
                        } exact />
                        <Route path="/my-videos" element={
                            <RequireAuth>
                                <MyVideosPage />
                            </RequireAuth>
                        } exact />
                        {/*Video view page */}
                        <Route path="/video-view-page/:productId" element={
                            // <RequireAuth>
                            <VideoViewPage />
                            // </RequireAuth>
                            // <RequireAuth>
                            // </RequireAuth>
                        } exact />
                        <Route path="/video-view-page-mobile/:productId" element={<VideoViewPageMobile />} />
                        {/* Report Pages */}
                        <Route path="/report" element={
                            <RequireAuth>
                                <ReportDashboard />
                            </RequireAuth>
                        } exact />
                        <Route
                            path="/progress-report&isOnboarding=true"
                            element={
                                <RequireAuth>
                                    <OnboardReportPage />
                                </RequireAuth>} exact
                        />
                        <Route
                            path="/progress-report&isOnboardingMobile=true"
                            element={<OnboardReportPageMobile />}
                        />
                        <Route path="/profile-report" element={
                            <RequireAuth>
                                <ProfileCompletionReportPage />
                            </RequireAuth>
                        } exact />
                        <Route
                            path="/progress-report&isLearningPath=true"
                            element={
                                <RequireAuth>
                                    <LearningPathProgressReportPage />
                                </RequireAuth>
                            } exact
                        />

                        <Route
                            path="/lp-report"
                            element={
                                <RequireAuth>
                                    <LearningPathProgressReportPage />
                                </RequireAuth>
                            } exact
                        />

                        <Route
                            path="/lp-report-mobile"
                            element={<LearningPathProgressReportPageMobile />}
                        />

                        <Route
                            path="/lp-report-office-detail"
                            element={
                                <RequireAuth>
                                    <LearningPathOfficeDetailPage />
                                </RequireAuth>
                            } exact
                        />
                        <Route
                            path="/lp-report-office-mobile-detail"
                            element={<LearningPathOfficeDetailMobilePage />}
                        />

                        <Route
                            path="/lp-report-rea-detail"
                            element={
                                <RequireAuth>
                                    <LearningPathReaDetailPage />
                                </RequireAuth>
                            } exact
                        />

                        <Route
                            path="/lp-report-rea-mobile-detail"
                            element={<LearningPathReaDetailMobilePage />}
                        />


                        <Route path="/course-report" element={
                            <RequireAuth>
                                <CourseProgressReportPage />
                            </RequireAuth>
                        } />
                        <Route path="/codeofethics-report" element={
                            <RequireAuth>
                                <CodeOfEthicsReportPage />
                            </RequireAuth>
                        } />
                        <Route path="/codeofethicsMobile-report" element={<CodeOfEthicsReportPageMobile />} />
                        <Route path="/systemusage-report" element={<SystemUsageReports />} />
                        <Route path="/systemusageMobile-report" element={<SystemUsageReportsMobile />} />
                        <Route path="/learningpath-survey-report" element={<LearningPathSurveyReport />} />
                        <Route path="/learningpath-survey-report-mobile" element={<LearningPathSurveyReportMobile />} />
                        <Route path="/event-report" element={
                            <RequireAuth>
                                <EventReportPage />
                            </RequireAuth>
                        } />
                        <Route path="/purchase-report" element={<PurchaseReport />} />
                        <Route path="/plan-upgrade-report" element={<PlanUpgradeReport />} />

                        {/* RolePlay  Page */}
                        <Route path="/role-play" element={
                            <RequireAuth>
                                <RolePlay />
                            </RequireAuth>
                        } />
                        <Route path="/review-role-play" element={
                            <RequireAuth>
                                <ReviewRolePlay />
                            </RequireAuth>
                        } />
                        <Route path="/my-role-plays" element={
                            <RequireAuth>
                                <MyRolePlays />
                            </RequireAuth>
                        } />
                        <Route path="/review-roleplay" element={
                            <RequireAuth>
                                <ReviewsRolePlays />
                            </RequireAuth>
                        } />
                        <Route path="/to-review" element={
                            <RequireAuth>
                                <ToReview />
                            </RequireAuth>
                        } />
                        <Route path="/role-play-mobile" element={<RolePlayMobile />} />
                        <Route path="/review-role-play-mobile" element={<ReviewRolePlayMobile />} />
                        <Route path="/my-role-play-mobile" element={<MyRolePlayMobile />} />

                        <Route path="/privacy-and-terms" element={<PrivacyandTerms />} />
                        <Route path="/privacy-and-terms-mobile" element={<PrivacyandTermsMobile />} />

                        {/* MyWall Page */}
                        <Route path="/my-wall" element={
                            <RequireAuth>
                                <MyWallPage />
                            </RequireAuth>
                        } />
                        <Route path="/testTron" element={<Test />} />
                        <Route path="/progress-report" element={
                            <RequireAuth>
                                <ProgressReportPage />
                            </RequireAuth>
                        } />
                        <Route path="/progress-reportMobile" element={<ProgressReportPageMobile />} />
                        <Route
                            path="/compliance-report"
                            element={
                                <RequireAuth>
                                    <ComplianceReportPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/compliance-report-mobile"
                            element={<ComplianceReportPageMobile />}
                        />
                        <Route
                            path="/compliance-report-detail"
                            element={
                                <RequireAuth>
                                    <ComplianceReportDetailPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/compliance-report-detail-mobile"
                            element={<ComplianceReportDetailPageMobile />}
                        />
                        <Route
                            path="/compliance-report-agent-detail"
                            element={
                                <RequireAuth>
                                    <ComplianceReportAgentDetailPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/compliance-report-agent-detail-mobile"
                            element={<ComplianceReportAgentDetailPageMobile />}
                        />

                        {/* Not Found Page */}
                        <Route path="/not-found" element={<NotFoundPage />} />

                        <Route path="/lpDetail" element={
                            // <RequireAuth>
                            // </RequireAuth>
                            // <RequireAuth>
                            <LPDetailPage />
                            // </RequireAuth>
                        } />
                        <Route path="/lpDetail-mobile" element={<LPDetailPageMobile />} />
                        <Route path="/levelDetail" element={
                            // <RequireAuth>
                            // </RequireAuth>
                            <LPDetailPage />
                        } />

                        <Route path="/bundleDetail" element={
                            // <RequireAuth>
                            // </RequireAuth>
                            <BundleDetailPage />
                        } />

                        {/* Footer Section Components */}
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-use" element={<TermsOfUse />} />
                        <Route path="/report-dashboard-mobile" element={<ReportDashboardMobile />} />
                        <Route path="/assign-content-modal" element={<AssignContentPage />} />
                        <Route path="/certificate-badges-mobile" element={<CertificateAndBadgeMobile />} />
                        <Route path="/toolbox" element={<MyToolBox />} />
                        <Route path="/504-error" element={<ServerErrorPage />} />
                        <Route path="/documentView" element={<DocumentView />} />
                        <Route path="/change-password" element={<ChangePasswordPage />} />
                        <Route path="/course-categories" element={
                            <RequireAuth>
                                <CourseCategories />
                            </RequireAuth>
                        } />
                        <Route path="/video-categories" element={
                            <RequireAuth>
                                <VideoCategoriesPage />
                            </RequireAuth>
                        } />
                        <Route path="/assigned-users" element={<AssignedUserList />} />
                        <Route path="/office-report" element={<AgentProgressReportPage />} />
                        <Route path="/account-activated" element={<SocialLoginActivation />} />
                        <Route path="/toolbox-file-upload-mobile" element={<FolderCreateFileUploadCompMobile />} />
                        <Route path="/sso" element={<FromSSOPage />} />
                        <Route path="/my-subscription" element={<MySubscriptionPage />} />
                        <Route path="/subscription" element={<ConditionalRenderingForSubscription />} />
                        {/*<Route path="*" element={<NotFoundPageWithouHeader} />*/}
                        <Route path="/home-b2c" element={<HomePageB2C />} exact />


                        {/* B2C ROUTES ADD FROM HERE */}

                        {/* COMPANY ROUTES */}
                        <Route path=":company" element={
                            <RequireAuth>
                                <Route path="" element={<HomePage />} exact />
                            </RequireAuth>
                        }>
                            <Route index element={<HomePage />} />



                            {/* <Route path="*" element={<HomePage />} exact /> */}
                            {/* <Route path={"learn/courses?tab=1"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } />
                        <Route path={"learn/courses?tab=2"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } />
                        <Route path={"learn/courses?tab=3"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } />
                        <Route path={"learn/courses?tab=4"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } />
                        <Route path={"learn/courses?tab=5"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } />
                        <Route path={"learn/courses?tab=6"} element={
                            <RequireAuth>
                                <LearnParentPage type="courses" />
                            </RequireAuth>
                        } /> */}
                        </Route>

                        {/* Home Page */}
                        {/* <Route path="/" element={
                        // <RequireAuth>
                        //     <HomePage />
                        // </RequireAuth>
                        <LoginPage />
                    } exact /> */}
                        {/*<Route path="/" element={
                        <LoginPage />
                    } exact />*/}

                        <Route path="/" element={
                            <RequireAuth>
                                <HomePage />
                            </RequireAuth>
                        } exact />

                        {/*For Test */}
                        <Route path={"/learn/courses"} element={<LearnParentPage type="courses" />} />
                        <Route path={"/learn/courses?tab=1"} element={<LearnParentPage type="courses" />} />
                        <Route path={"/learn/courses?tab=2"} element={<LearnParentPage type="courses" />} />
                        <Route path={"/learn/courses?tab=6"} element={<LearnParentPage type="courses" />} />
                        <Route path={"/learn/courses?tab=3"} element={<LearnParentPage type="courses" />} />

                        <Route path={"/learn/learningpath"} element={<LearnParentPage type="learningpath" />} />
                        <Route path={"/learn/learningpath?tab=3"} element={<LearnParentPage type="learningpath" />} />
                        <Route path={"/learn/learningpath?tab=4"} element={<LearnParentPage type="learningpath" />} />
                        <Route path={"/learn/learningpath?tab=5"} element={<LearnParentPage type="learningpath" />} />

                        {/* LEARN PAGES */}
                        <Route path="/learn-page" element={<LearnParentPage type="courses" />} />
                        <Route path={routeList.LEARN_COURSES_PAGE} element={<LearnParentPage type="courses" />} />
                        <Route path={routeList.LEARN_VIDEOS_PAGE} element={<LearnParentPage type="videos" />} />
                        <Route path={routeList.LEARN_LEARNING_PATH_PAGE} element={<LearnParentPage type="learningpath" />} />
                        <Route path={routeList.LEARN_CERTIFICATIONS_PAGE} element={<LearnParentPage type="certifications" />} />
                        <Route path={routeList.LEARN_EVENTS_PAGE} element={<LearnParentPage type="events" />} />
                        <Route path={routeList.LEARN_COACHING_PAGE} element={<LearnParentPage type="coaching" />} />
                        <Route path={routeList.LEARN_ROLEPLAY_PAGE} element={<LearnParentPage type="roleplay" />} />
                        <Route path={routeList.LEARN_OTHERS_PAGE} element={<LearnParentPage type="others" />} />
                        <Route path={routeList.LEARN_COMBO_PAGE} element={<LearnParentPage type="combo" />} />
                        <Route path="/our-partners" element={<PartnerListPage type="all" />} />
                        <Route path="/our-partners/courses" element={<PartnerListPage type="courses" />} />
                        <Route path="/our-partners/videos" element={<PartnerListPage type="videos" />} />
                        <Route path="/our-partners/coaching" element={<PartnerListPage type="coaching" />} />
                        <Route path="/our-partners/events" element={<PartnerListPage type="event" />} />
                        <Route path="/our-partners/certifications" element={<PartnerListPage type="certificate" />} />
                        <Route path="/our-partners/learningpath" element={<PartnerListPage type="lp" />} />
                        <Route path="/partner-detail" element={<PartnerDetailPage type="intro" />} />
                        <Route path="/partner-detail/courses" element={<PartnerDetailPage type="courses" />} />
                        <Route path="/partner-detail/videos" element={<PartnerDetailPage type="videos" />} />
                        <Route path="/partner-detail/coaching" element={<PartnerDetailPage type="coaching" />} />
                        <Route path="/partner-detail/events" element={<PartnerDetailPage type="event" />} />
                        <Route path="/partner-detail/certifications" element={<PartnerDetailPage type="certificate" />} />
                        <Route path="/partner-detail/learningpath" element={<PartnerDetailPage type="learningpath" />} />
                        <Route path="/certify-detail" element={<CertificationDetailsPage />} exact />
                        <Route path="/event-detail" element={<EventDetailPage />} exact />
                        <Route path="/product/checkout" element={<PaymentB2CPage type="product" />} exact />
                        <Route path="/product/checkout-mobile" element={<PaymentB2CPageMobile type="product" />} exact />
                        <Route path={routeList.COACHING_CHECKOUT_PAGE} element={<PaymentB2CPage type="coaching" />} exact />
                        <Route path="/subscription/checkout" element={<PaymentB2CPage type="subscription" />} exact />
                        <Route path="/subscription/checkout-mobile" element={<PaymentB2CPageMobile type="subscription" />} exact />
                        <Route path="/payment-b2c" element={<PaymentB2CPage />} exact />
                        <Route path="/payment-summary" element={<PaymentSummaryB2CPage />} exact />
                        <Route path="/payment/processing" element={<PaymentStatusB2CPage />} exact />
                        <Route path={routeList.VIEW_SUBSCRRIPTION_RECEIPT} element={<ViewSubscriptionReceiptPage />} exact />
                        <Route path={routeList.PAYMENT_UPDATE_PAGE} element={
                            <RequireAuth>
                                <PaymentMethodAddPage />
                            </RequireAuth>
                        } exact />
                        <Route path={routeList.PAYMENT_UPDATE_MOBILE_PAGE} element={

                            <PaymentMethodAddMobilePage />

                        } exact />
                        <Route path="/sign-up" element={<SignUpPage />} exact />

                        {/* B2C Roleplay */}
                        <Route path="/learn/roleplay/detail/:roleplayId" element={<RolePlayDetailPage />} exact />
                        <Route path="/learn/roleplay/detailForTour/" element={<TourDetailPage />} exact />
                        <Route path="/live-events" element={<LiveEventsMarketingCalendar />} exact />
                        <Route path="/coaching-detail" element={<CoachingDetailPage />} exact />
                        <Route path="/coaching-detail-mobile" element={<CoachingDetailPageMobile />} />
                        <Route path="/contact" element={<EventsRegistrationPage />} exact />
                        <Route path="/market-events" element={<MarketingCalendar />} />
                        <Route path="/discuss-page-mobile" element={<DetailLearnDiscussMobilePage />
                        } exact />
                        <Route path="/podcast-fb-feeds-mobile" element={<PodcastAndFBFeedMobile />} />
                        <Route path="/certificate-badges-mobile" element={<CertificateAndBadgeMobile />} />
                        <Route path="/orders-copy" element={
                            <RequireAuth>
                                <OrderHistoryPageCopy />
                            </RequireAuth>
                        } exact />
                        <Route path="/bundleDetail-mobile" element={
                            <BundleDetailPageMobile />
                        } />
                        <Route path="/assigned-users-mobile" element={<AssignedUserListMobile />} />
                        <Route path="/learn/roleplay-review/detail/:roleplayId" element={<RolePlayReviewDetailPage />} exact />
                        <Route path={"/learn/survey"} element={<FormBuilderPage />} />
                        <Route path={"/learn/show-survey"} element={<FormGeneratorSection />} />
                        <Route path="/learn/roleplay?tab=1" element={<RolePlayListingMainComponent />} />
                        <Route path="/learn/roleplay?tab=2" element={<RolePlayListingMainComponent />} />
                        <Route path="/learn/roleplay?tab=3" element={<RolePlayListingMainComponent />} />
                        <Route path="/my-teamlist" element={<RequireAuth><MyTeamListPage /></RequireAuth>} />
                        <Route path="/leaderboard" element={<LeaderBoardPage />} />
                        <Route path="/certificates-mobile" element={<CertificateAndBadgeMobile />} />
                        <Route path="/badges-mobile" element={<BadgesMobile />} />
                        <Route path="/login-sso" element={<LoginSSO />} />
                        <Route path="/auth/callback" element={<GoogleAuthCallback />} />
                        <Route path="/sso/outh/google" element={<GoogleAuthCall />} />
                        <Route path="/subscription-updated" element={<SubscriptionPriceSectionUpdatedComp />} />
                        <Route path="/flash-term" element={<FlashTermAndCondPage />} />

                        {/* Form Builder */}
                        <Route path="/survey-builder" element={<FormBuilderPage />} />
                        <Route path="/survey-builder-mobile" element={<FormBuilderMobilePage />} />
                        <Route path="/survey-generator/:surveyId" element={<FormGeneratorPage />} />
                        <Route path="/survey-generator-mobile/:surveyId" element={<FormGeneratorPageMobile />} />
                        <Route path="/subscription-payments" element={<SubscriptionPaymentsPage />} />
                    </Routes>
                </WebhookProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}



export default App;
